module.exports = __webpack_public_path__ + "img/hourglass.0ae8f9f0.svg";